import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";

export const getCartToken = (): string => getGlobalProperty("cartToken") ?? "";
